import { PlusIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import { ReactElement } from "react";

import { Button } from "./catalyst/Button";
import { PageAction } from "./PageLayout";

const SideBarActionButton = ({
  href,
  icon,
  label,
  onClick,
}: PageAction): ReactElement => {
  return (
    <Button
      aria-label={label}
      className={clsx(
        "shrink-0 rounded-lg p-1.5",
        "data-[slot=icon]:*:size-4 data-[slot=icon]:*:fill-zinc-500",
        "dark:data-[slot=icon]:*:fill-zinc-400",
      )}
      href={href}
      onClick={onClick}
      plain
      size="xs"
    >
      {icon || <PlusIcon data-slot="icon" />}
    </Button>
  );
};

export default SideBarActionButton;
